<div style="width: 100%; height: 100vh; overflow-y: scroll;"> 
<div fxLayout="row" fxLayoutAlign="end center" >
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="center center" >
    <label mat-dialog-title class="otpHeader" >Select welcome banner for your MiniApps</label>
   <p>Select a template of your choice and edit the text as per your MiniApps</p>
</div>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px" class = "hidden-sm">
    <mat-radio-group fxLayout="row" fxLayoutGap="10px" class="example-radio-group" [(ngModel)]="selectedTemplate"  (change)="radioChange()">
      <div fxLayout="column" fxLayoutGap="20px" class="template-section">
     
        <div  fxLayout="column" fxFlexGap="20px" class="template-background-1" fxLayoutAlign="space-between center" id="template1">
          <div  fxLayout="column">
            <div fxLayout="column" class="textarea-wrapper">
              <div *ngIf='!editMode1' (click)='editMode1=true' class='input-main-title'>{{ data1}}</div>
              <textarea *ngIf='editMode1' (focusout)="onFocusOut()" [(ngModel)]='data1' class='cellInput'
                appAutofocus type='text'  (focusout)="editMode1=false"  maxlength="40" ></textarea>
                <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode1' src="assets/edit.svg"  width="15px" height="15px"/></span>
                <span class="remaining" *ngIf='editMode1'>{{data1.length}}/40</span>
            </div>
            <div  fxLayout="column" class="textarea-wrapper">
              <div *ngIf='!editMode1' (click)='editMode1=true' class='input-second-title' >{{ data2}}</div>
              <textarea *ngIf='editMode1' (focusout)="onFocusOut()" [(ngModel)]='data2' class='cellInput'
                appAutofocus type='text'  (focusout)="editMode1=false" maxlength="80"></textarea>
                <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode1' src="assets/edit.svg"  width="15px" height="15px"/></span>
                <span class="remaining" *ngIf='editMode1'>{{data2.length}}/80</span>
            </div>
          </div>
         
          <div  fxLayout="column" fxLayoutAlign="end end">
           <img class="user-header-image"  src="assets/template-1-icon-image.svg">
           </div>
        </div>
       
        <mat-radio-button class="example-radio-button" value="1" >
          Template -1
        </mat-radio-button>
      </div>
      <div fxLayout="column" fxLayoutGap="20px" class="template-section">
     
        <div  fxLayout="column" fxFlexGap="10px" class="template-background-2" fxLayoutAlign="space-between center" id="template2">
          <div  fxLayout="column">
            <div fxLayout="column" class="textarea-wrapper">
              <div *ngIf='!editMode2' (click)='editMode2=true' class='input-main-title'>{{ data3}}</div>
              <textarea *ngIf='editMode2' (focusout)="onFocusOut()" [(ngModel)]='data3' class='cellInput'
                appAutofocus type='text'  (focusout)="editMode2=false" maxlength="40"></textarea>
                <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode2' src="assets/edit.svg"  width="15px" height="15px"/></span>
                <span class="remaining" *ngIf='editMode2'>{{data3.length}}/40</span>
            </div>
            <div  fxLayout="column" class="textarea-wrapper">
              <div *ngIf='!editMode2' (click)='editMode2=true' class='input-second-title'>{{ data4}}</div>
              <textarea *ngIf='editMode2' (focusout)="onFocusOut()" [(ngModel)]='data4' class='cellInput'
                appAutofocus type='text'  (focusout)="editMode2=false" maxlength="80"></textarea>
                <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode2' src="assets/edit.svg"  width="15px" height="15px"/></span>
                <span class="remaining" *ngIf='editMode2'>{{data4.length}}/80</span>
            </div>
          </div>
         
          <div  fxLayout="column" fxLayoutAlign="end end">
           <img class="user-header-image"  src="assets/template-2-icon-image.svg">
           </div>
        </div>
       
        <mat-radio-button class="example-radio-button" value="2" >
          Template -2
        </mat-radio-button>
      </div>
      <div fxLayout="column" fxLayoutGap="20px" class="template-section">
     
        <div  fxLayout="column" fxFlexGap="10px" class="template-background-3" fxLayoutAlign="space-between center" id="template3">
          <div  fxLayout="column">
            <div fxLayout="column" class="textarea-wrapper">
              <div *ngIf='!editMode3' (click)='editMode3=true' class='input-main-title'>{{ data5}}</div>
              <textarea *ngIf='editMode3' (focusout)="onFocusOut()" [(ngModel)]='data5' class='cellInput'
                appAutofocus type='text'  (focusout)="editMode3=false"  maxlength="40"></textarea>
                <span class="edit-icon" fxLayoutAlign="end end" ><img *ngIf='editMode3' src="assets/edit.svg"  width="15px" height="15px"/></span>
                <span class="remaining" *ngIf='editMode3'>{{data5.length}}/40</span>
            </div>
            <div  fxLayout="column" class="textarea-wrapper">
              <div *ngIf='!editMode3' (click)='editMode3=true' class='input-second-title'>{{ data6}}</div>
              <textarea *ngIf='editMode3' (focusout)="onFocusOut()" [(ngModel)]='data6' class='cellInput'
                appAutofocus type='text'  (focusout)="editMode3=false"  maxlength="80"></textarea>
                <span class="edit-icon" fxLayoutAlign="end end" ><img *ngIf='editMode3' src="assets/edit.svg"  width="15px" height="15px"/></span>
                <span class="remaining" *ngIf='editMode3'>{{data6.length}}/80</span>
            </div>
          </div>
         
          <div  fxLayout="column" fxLayoutAlign="end end">
           <img class="user-header-image"  src="assets/template-3-icon-image.svg">
           </div>
        </div>
       
        <mat-radio-button class="example-radio-button" value="3" >
          Template -3
        </mat-radio-button>
      </div>
      
      <!-- <div fxLayout="column" fxLayoutGap="10px" class="template-section">
        <img class="user-header-image" src="assets/template-3.svg">
        <mat-radio-button class="example-radio-button" value="3" >
          Template -3
        </mat-radio-button>
      </div> -->
    </mat-radio-group>
    <div fxLayout="row" fxLayoutAlign="center center" style="width:100%">
      <button   class="verify-btn" [disabled]="!selectedTemplate" (click)="editMode1=false;editMode2=false;editMode3=false;saveSelectedTemplate(0)"
    fxLayoutAlign="center center"  fxFlex="30"style="padding:10px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';
    font-style: normal;font-size: 14px; ">Save<mat-icon>
      chevron_right
    </mat-icon>
  </button>

    </div>
    

</div>
<div style="flex-direction: column;box-sizing: border-box;display: flex;" class = "hidden-xl"> 
  <div>
    <button [ngClass] ="{'responsive-template-cutom-button-styles-active' : (selectedTemplate == '1'),'responsive-template-cutom-button-styles' : (selectedTemplate != '1')}"   (click)="selectedTemplate ='1';radioChange()">Template -1</button>
    <button [ngClass] ="{'responsive-template-cutom-button-styles-active' : (selectedTemplate == '2'),'responsive-template-cutom-button-styles' : (selectedTemplate != '2')}"  (click)="selectedTemplate ='2';radioChange()">Template -2</button>
    <button [ngClass] ="{'responsive-template-cutom-button-styles-active' : (selectedTemplate == '3'),'responsive-template-cutom-button-styles' : (selectedTemplate != '3')}"   (click)="selectedTemplate ='3';radioChange()"> Template -3</button>

  </div>
  <div  *ngIf = "selectedTemplate == '1'" fxLayout="column" fxFlexGap="20px" class="template-background-1" fxLayoutAlign="space-between center" id="template1">
  <div  fxLayout="column">
    <div fxLayout="column" class="textarea-wrapper">
      <div *ngIf='!editMode1' (click)='editMode1=true' class='input-main-title'>{{ data1}}</div>
      <textarea *ngIf='editMode1' (focusout)="onFocusOut()" [(ngModel)]='data1' class='cellInput'
        appAutofocus type='text'  (focusout)="editMode1=false"  maxlength="40" ></textarea>
        <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode1' src="assets/edit.svg"  width="15px" height="15px"/></span>
        <span class="remaining" *ngIf='editMode1'>{{data1.length}}/40</span>
    </div>
    <div  fxLayout="column" class="textarea-wrapper">
      <div *ngIf='!editMode1' (click)='editMode1=true' class='input-second-title' >{{ data2}}</div>
      <textarea *ngIf='editMode1' (focusout)="onFocusOut()" [(ngModel)]='data2' class='cellInput'
        appAutofocus type='text'  (focusout)="editMode1=false" maxlength="80"></textarea>
        <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode1' src="assets/edit.svg"  width="15px" height="15px"/></span>
        <span class="remaining" *ngIf='editMode1'>{{data2.length}}/80</span>
    </div>
  </div>
 
  <div  fxLayout="column" fxLayoutAlign="end end">
   <img class="user-header-image"  src="assets/template-1-icon-image.svg">
   </div>
  </div>  
  <div *ngIf = "selectedTemplate == '2'" fxLayout="column" fxFlexGap="10px" class="template-background-2" fxLayoutAlign="space-between center" id="template2">
    <div  fxLayout="column">
      <div fxLayout="column" class="textarea-wrapper">
        <div *ngIf='!editMode2' (click)='editMode2=true' class='input-main-title'>{{ data3}}</div>
        <textarea *ngIf='editMode2' (focusout)="onFocusOut()" [(ngModel)]='data3' class='cellInput'
          appAutofocus type='text'  (focusout)="editMode2=false" maxlength="40"></textarea>
          <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode2' src="assets/edit.svg"  width="15px" height="15px"/></span>
          <span class="remaining" *ngIf='editMode2'>{{data3.length}}/40</span>
      </div>
      <div  fxLayout="column" class="textarea-wrapper">
        <div *ngIf='!editMode2' (click)='editMode2=true' class='input-second-title'>{{ data4}}</div>
        <textarea *ngIf='editMode2' (focusout)="onFocusOut()" [(ngModel)]='data4' class='cellInput'
          appAutofocus type='text'  (focusout)="editMode2=false" maxlength="80"></textarea>
          <span class="edit-icon" fxLayoutAlign="end start" ><img *ngIf='editMode2' src="assets/edit.svg"  width="15px" height="15px"/></span>
          <span class="remaining" *ngIf='editMode2'>{{data4.length}}/80</span>
      </div>
    </div>
   
    <div  fxLayout="column" fxLayoutAlign="end end">
     <img class="user-header-image"  src="assets/template-2-icon-image.svg">
     </div>
  </div>
  <div *ngIf = "selectedTemplate == '3'" fxLayout="column" fxFlexGap="10px" class="template-background-3" fxLayoutAlign="space-between center" id="template3">
    <div  fxLayout="column">
      <div fxLayout="column" class="textarea-wrapper">
        <div *ngIf='!editMode3' (click)='editMode3=true' class='input-main-title'>{{ data5}}</div>
        <textarea *ngIf='editMode3' (focusout)="onFocusOut()" [(ngModel)]='data5' class='cellInput'
          appAutofocus type='text'  (focusout)="editMode3=false"  maxlength="40"></textarea>
          <span class="edit-icon" fxLayoutAlign="end end" ><img *ngIf='editMode3' src="assets/edit.svg"  width="15px" height="15px"/></span>
          <span class="remaining" *ngIf='editMode3'>{{data5.length}}/40</span>
      </div>
      <div  fxLayout="column" class="textarea-wrapper">
        <div *ngIf='!editMode3' (click)='editMode3=true' class='input-second-title'>{{ data6}}</div>
        <textarea *ngIf='editMode3' (focusout)="onFocusOut()" [(ngModel)]='data6' class='cellInput'
          appAutofocus type='text'  (focusout)="editMode3=false"  maxlength="80"></textarea>
          <span class="edit-icon" fxLayoutAlign="end end" ><img *ngIf='editMode3' src="assets/edit.svg"  width="15px" height="15px"/></span>
          <span class="remaining" *ngIf='editMode3'>{{data6.length}}/80</span>
      </div>
    </div>
   
    <div  fxLayout="column" fxLayoutAlign="end end">
     <img class="user-header-image"  src="assets/template-3-icon-image.svg">
     </div>
  </div>
  <button   class="verify-btn" [disabled]="!selectedTemplate" (click)="editMode1=false;editMode2=false;editMode3=false;saveSelectedTemplate(1)"
    fxLayoutAlign="center center"  fxFlex="30"style="padding:10px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';
    font-style: normal;font-size: 14px; ">Save<mat-icon>
      chevron_right
    </mat-icon>
  </button>
</div>
</div>